import React from 'react';
import {
    Box,
    Grid,
    Paper,
    Typography,
    Chip,
    List,
    ListItem,
    ListItemText,
    Collapse
} from '@mui/material';
import {
    People as PeopleIcon,
    Storage as StorageIcon,
    ExpandMore as ExpandMoreIcon,
    ExpandLess as ExpandLessIcon
} from '@mui/icons-material';
import { useSelector } from 'react-redux';
import TEXT from './text';

const GroupOverview = ({ groupId, groupName, overview }) => {
    const language = useSelector(state => state.App_Settings.language);
    const [showChildGroups, setShowChildGroups] = React.useState(false);
    
    const childGroups = []; // TODO: Fetch child groups from API
    
    return (
        <Box sx={{ p: 3 }}>
            <Grid container spacing={3} sx={{ mt: 1 }}>
                {/* Total Records */}
                <Grid item xs={12} sm={4}>
                    <Box 
                        sx={{ 
                            p: 2, 
                            borderRadius: 2, 
                            bgcolor: 'primary.light',
                            color: 'primary.contrastText'
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1}}>
                            {/*<StorageIcon />*/}
                            <Typography variant="subtitle2">
                                {TEXT.TotalRecords[language]}
                            </Typography>
                        </Box>
                        <Typography variant="h4">
                            {overview?.total_records?.toLocaleString() || '0'}
                        </Typography>
                        {overview?.recent_growth > 0 && (
                            <Typography variant="caption" sx={{ opacity: 0.9 }}>
                                +{overview.recent_growth} {TEXT.Last7Days[language]}
                            </Typography>
                        )}
                    </Box>
                </Grid>
                
                {/* Total Users */}
                <Grid item xs={12} sm={4}>
                    <Box 
                        sx={{ 
                            p: 2, 
                            borderRadius: 2, 
                            bgcolor: 'secondary.light',
                            color: 'secondary.contrastText'
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                            {/* <PeopleIcon /> */}
                            <Typography variant="subtitle2">
                                {TEXT.TotalUsers[language]}
                            </Typography>
                        </Box>
                        <Typography variant="h4">
                            {overview?.user_count?.toLocaleString() || '0'}
                        </Typography>
                        {/* <Typography variant="caption" sx={{ opacity: 0.9 }}>
                            {TEXT.TotalUsers[language]}
                        </Typography> */}
                    </Box>
                </Grid>
                
                {/* Average Daily Growth */}
                <Grid item xs={12} sm={4}>
                    <Box 
                        sx={{ 
                            p: 2, 
                            borderRadius: 2, 
                            bgcolor: 'info.light',
                            color: 'info.contrastText'
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                            {/* <StorageIcon /> */}
                            <Typography variant="subtitle2">
                                {TEXT.average_daily[language]}
                            </Typography>
                        </Box>
                        <Typography variant="h4">
                            {overview?.average_daily?.toFixed(1) || '0'}
                        </Typography>
                        {/* <Typography variant="caption" sx={{ opacity: 0.9 }}>
                            {TEXT.Records[language]} {TEXT.PerDay[language]}
                        </Typography> */}
                    </Box>
                </Grid>
            </Grid>
            
            {/* Child Groups */}
            {childGroups.length > 0 && (
                <Box sx={{ mt: 3 }}>
                    <Box 
                        sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: 1, 
                            cursor: 'pointer',
                            mb: 1
                        }}
                        onClick={() => setShowChildGroups(!showChildGroups)}
                    >
                        <Typography variant="subtitle1">
                            {TEXT.ChildGroups[language]} ({childGroups.length})
                        </Typography>
                        {showChildGroups ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                    
                    <Collapse in={showChildGroups}>
                        <List dense>
                            {childGroups.map((child, index) => (
                                <ListItem key={index} sx={{ pl: 0 }}>
                                    <ListItemText 
                                        primary={child.name}
                                        secondary={`${child.record_count} ${TEXT.Records[language]}`}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </Collapse>
                </Box>
            )}
            
            {childGroups.length === 0 && (
                <Box sx={{ mt: 2 }}>
                    <Typography variant="caption" color="text.secondary">
                        {TEXT.NoChildGroups[language]}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default GroupOverview;
